import { isWizardQuestion, type Wizard, type WizardRendererParams } from "./wizard"

export function renderWizard<T>(props: { wizard: Wizard<T> }) {
    const { wizard } = props

    return (
        <div>
            <div class="mb-4">
                {wizard.questionStack.map((question, index) => (
                    <div
                        class="wizard-button-back d-flex align-items-center pl-3"
                        onClick={() => question.goBack()}
                        key={index}
                    >
                        <div>
                            <i class="fa fa-fw fa-arrow-left mr-2 text-primary"></i>
                        </div>
                        <div>
                            <div class="small font-weight-normal">{question.label}</div>
                            {question.answerLabel}
                        </div>
                    </div>
                ))}
            </div>

            <h4>{wizard.currentComponent?.label}</h4>
            {wizard.currentComponent?.render({ wizard, component: wizard.currentComponent })}
        </div>
    )
}

export function renderQuestion<Result>(params: WizardRendererParams<Result>) {
    const { component } = params

    if (!isWizardQuestion(component)) {
        throw new Error("Component that is not a question was passed to renderQuestion")
    }

    return (
        <>
            {component.answers.map(answer => (
                <div
                    class={[
                        "wizard-button",
                        answer.disabled ? "wizard-button-disabled" : null,
                    ]}
                    onClick={() => answer.select()}
                    aria-disabled={answer.disabled}
                >
                    {answer.label}
                </div>
            ))}
        </>
    )
}
